import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useTheme } from '@mui/material/styles';
import { Theme as AugmentedTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Icon, Typography } from 'web-library';
import { candidateService } from '../../../api';
import { stringToLongDateAndShortTime } from '../../../utils/DateUtils';

const useStyles = makeStyles()((theme) =>
({
  root: {
    display: 'flex',
    marginTop: theme.spacing(3),
  },
  draftIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  draftMessage: {
    fontWeight: 700,
    color: theme.color.text.textTertiary,
    marginLeft: theme.spacing(1),
  },
}));

const ExamDraftMessage = ({ enableApi = true }: { enableApi?: boolean }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles();
  const [draftMessage, setDraftMessage] = useState<string>();

  // @ts-ignore
  const { uuid: examRegistrationUuid } = useParams();

  const { data } = candidateService.exam.candidate.useGetExamRegistration(examRegistrationUuid, {
    enabled: enableApi,
  });

  useEffect(() => {
    if (examRegistrationUuid && data) {
      setDraftMessage(
        `${t('exam->>RegisterExam.DraftSavedAt')} ${stringToLongDateAndShortTime(
          data.lastUpdatedTime
        )}`
      );
    }
  }, [data, examRegistrationUuid, t]);

  return (
    <>
      {draftMessage && (
        <div className={classes.root}>
          <div className={classes.draftIcon}>
            <Icon
              className={classes.draftIcon}
              name={IconName.clock}
              size="M"
              color={theme.color.icon.iconDefault}
            />
          </div>

          <Typography className={classes.draftMessage}>{draftMessage}</Typography>
        </div>
      )}
    </>
  );
};
export default ExamDraftMessage;
